import { create } from "zustand";

const useStyleSelectionStore = create((set) => ({
  selection: { mode: "profile_default" },
  setSelection: (selection) => set({ selection }),
  resetSelection: () => set({ selection: { mode: "profile_default" } }),
}));

export default useStyleSelectionStore;